module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('PlanoScaffold', [_c('Loader', {
    attrs: {
      "loading": true
    }
  }), _vm._v(" "), _c('PlanoHeader', [_c('OutlineButton', {
    on: {
      "click": function($event) {
        _vm.exit();
      }
    },
    slot: "trailing"
  }, [_vm._v(_vm._s(_vm.$t("plano.editor.header.file.exit")))])], 1), _vm._v(" "), _c('PlanoNav', {
    attrs: {
      "exitTo": "/planos"
    }
  })], 1) : (_vm.planoNotFound) ? _c('PlanoScaffold', [_c('PlanoHeader', [_c('OutlineButton', {
    on: {
      "click": function($event) {
        _vm.exit();
      }
    },
    slot: "trailing"
  }, [_vm._v(_vm._s(_vm.$t("plano.editor.header.file.exit")))])], 1), _vm._v(" "), _c('PlanoNav', {
    attrs: {
      "exitTo": "/planos"
    }
  }), _vm._v(" "), _c('Error', {
    attrs: {
      "codeError": "404"
    }
  })], 1) : _c('PlanoScaffold', {
    attrs: {
      "datas": _vm.plano
    },
    on: {
      "rename-favorite": _vm.renameFavorite
    }
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.saving || _vm.rasterizing
    }
  }), _vm._v(" "), _c('Lock', {
    ref: "lock",
    attrs: {
      "planoId": _vm.planoId
    }
  }), _vm._v(" "), _c('PlanoHeader', {
    attrs: {
      "plano": _vm.plano,
      "logoUrl": _vm.logoUrl
    }
  }, [(!_vm.isReadOnly) ? _c('OutlineButton', {
    on: {
      "click": function (e) { return _vm.save(); }
    },
    slot: "trailing"
  }, [_vm._v(_vm._s(_vm.$t("plano.editor.header.file.save")))]) : _vm._e(), _vm._v(" "), _c('OutlineButton', {
    on: {
      "click": function($event) {
        _vm.exit();
      }
    },
    slot: "trailing"
  }, [_vm._v(_vm._s(_vm.$t("plano.editor.header.file.exit")))])], 1), _vm._v(" "), _c('PlanoNav', {
    attrs: {
      "locked": _vm.isReadOnly,
      "exitTo": "/planos",
      "plano": _vm.plano
    },
    on: {
      "exportPdf": _vm.exportPdf,
      "exportXls": _vm.exportXls,
      "nameChanged": _vm.nameChanged,
      "save": _vm.save,
      "saveAs": function($event) {
        _vm.toggleModalSaveAs(true);
      },
      "saveAsTemplate": function($event) {
        _vm.toggleModalSaveAsTemplate(true);
      }
    }
  }), _vm._v(" "), (_vm.lockDetails) ? _c('LockStatus', {
    attrs: {
      "lockDetails": _vm.lockDetails,
      "locked": !_vm.isOwned,
      "readOnly": _vm.isReadOnly
    }
  }) : _vm._e(), _vm._v(" "), _c('PlanoEngine', {
    key: _vm.planoId,
    attrs: {
      "catalogPanes": _vm.catalogPanes,
      "catalogItems": _vm.catalogItems.value,
      "systemType": _vm.plano && _vm.plano.template.systemType.id,
      "brandId": _vm.plano && _vm.plano.brand.id,
      "zoneId": _vm.plano && _vm.plano.zone.id,
      "campaignId": _vm.plano && _vm.plano.campaign.id
    },
    on: {
      "search-changed": _vm.searchChanged,
      "save": function (e) { return _vm.save(); }
    }
  }), _vm._v(" "), (_vm.currentPlano) ? _c('InfosBar', {
    attrs: {
      "plano": _vm.currentPlano
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showExitModal) ? _c('ModalExitPlano', {
    attrs: {
      "name": _vm.plano.name,
      "readOnly": _vm.readOnly
    },
    on: {
      "save": function($event) {
        _vm.saveAfterExit($event);
      },
      "close": function($event) {
        _vm.closeExitModal();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalSaveAs && _vm.plano) ? _c('ModalSaveAsPlano', {
    attrs: {
      "plano": _vm.plano
    },
    on: {
      "exit": _vm.exit,
      "close": function($event) {
        _vm.toggleModalSaveAs(false);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalExportPdf && _vm.currentPlano) ? _c('ModalExportPdf', {
    attrs: {
      "plano": _vm.currentPlano
    },
    on: {
      "close": function($event) {
        _vm.toggleModalExportPdf(false);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalSaveAsTemplate && _vm.plano) ? _c('ModalSavePlanoAsToTemplate', {
    attrs: {
      "plano": _vm.plano
    },
    on: {
      "close": function($event) {
        _vm.toggleModalSaveAsTemplate(false);
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64fbb635","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/editor.vue
// module id = 3235
// module chunks = 0